/**
 * Welcome Step - First onboarding screen with Lottie animation
 */

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { OnboardingStep } from '../OnboardingStep';

export function WelcomeStep() {
  return (
    <OnboardingStep
      title="ยินดีต้อนรับสู่ Quran Assistant"
      description="อ่านอัลกุรอานแบบมุศฮัฟ พร้อมตัจวีด ตะดับบุร ตัฟซีรภาษาไทย ตั้งเป้าหมาย และติดตามความคืบหน้าได้ง่ายๆ"
      illustration={
        <div className="w-48 h-48">
          <DotLottieReact
            src="/welcome.json"
            loop
            autoplay
          />
        </div>
      }
    />
  );
}

export default WelcomeStep;
